import { jsx as d } from "react/jsx-runtime";
const n = "dds-tab-v0112";
function l({ children: o, className: t = "", selected: r, disabled: s, ...a }) {
  const i = (e = {}) => Object.keys(e).filter((c) => !!e[c]).join(" "), b = {
    [n]: !0,
    [`${n}--selected`]: !!r,
    [t]: t.length > 0
  };
  return /* @__PURE__ */ d(
    "button",
    {
      "aria-disabled": s ? "true" : void 0,
      className: i(b),
      type: "button",
      ...a,
      children: o
    }
  );
}
export {
  l as Tab
};
//# sourceMappingURL=index.js.map
